/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';

import SearchFieldsView from '../../common/views/SearchFieldsView';

export default async function loadSearchFields(searchFields, searchService, searchPassedParam = null) {
  // Filter out all search fields where renderable is set to false
  searchFields = searchFields.filter((field) => field?.renderable !== false);

  const lookupTables = await Promise.all(
    searchFields.map((searchField) => {
      if (searchField.class === 'SelectSearchField') {
        return searchField.lookupService();
      }
      return [];
    })
  );

  lookupTables.forEach((lookupTable, index) => {
    const mapping = searchFields[index].lookupMapping;
    const filter = searchFields[index].lookupFilter;

    if (filter) {
      lookupTable = lookupTable.filter(filter);
    }
    if (mapping) {
      lookupTable = lookupTable.map(mapping);
    }

    searchFields[index].lookupValues = lookupTable;
  });
  if (searchPassedParam?.commandId) {
    return new SearchFieldsView({
      model: new Backbone.Model({
        searchFields,
        searchService,
        commandId: searchPassedParam.commandId
      })
    });
  }
  return new SearchFieldsView({
    model: new Backbone.Model({
      searchFields,
      searchService
    })
  });
}
